<template>
  <div class="initialize-survey-step">
    <Typography variant="h-5">
      Start by giving your survey a name, description and image
    </Typography>

    <ClientDropdown :disabled="isEditing" @change="$emit('update:clientId', $event)" />

    <v-form ref="form">
      <div class="form-fields">
        <v-text-field
          outlined
          color="brandPrimary"
          label="Survey Name*"
          :value="name"
          hide-details="auto"
          :rules="[
            (v) => !!v || 'A name is required',
            (v) => !v || v.length <= 100 || 'Name must be 100 characters or fewer',
          ]"
          @input="$emit('update:name', $event)"
        />

        <v-textarea
          outlined
          hide-details
          color="brandPrimary"
          label="Brief survey description"
          :value="description"
          rows="4"
          @input="$emit('update:description', $event)"
        />
      </div>
    </v-form>

    <div>
      <Typography variant="subtitle-1" class="mb-1">Add a banner photo</Typography>
      <Typography variant="body-2" class="banner-description">
        We suggest an image size of 740 x 416 px (Or any image with a 16:9 aspect ratio). JPG, PNG
        files supported. Max file size: 10 MB.
        <a :href="defaultImageURL" class="default-image-link" target="_blank">A default image</a>
        will be used if you do not upload an image.
      </Typography>
    </div>

    <DragAndDropImageInput
      :max-file-size="10 * 1024 * 1024"
      :file="bannerFile"
      :existing-image-url="existingImageUrl"
      :aspect-ratio-value="16 / 9"
      :aspect-ratio-text="'16 : 9'"
      crop-image
      @file-selected="$emit('update:bannerFile', $event)"
      @clear-existing-image="$emit('clear-existing-image')"
    />
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import DragAndDropImageInput from "@/components/DragAndDropImageInput.vue";
import ClientDropdown from "@/components/ClientDropdown.vue";

export default {
  name: "InitializeSurveyStep",
  components: {
    Typography,
    DragAndDropImageInput,
    ClientDropdown,
  },
  props: {
    clientId: {
      type: [Number, String],
      default: null,
    },
    name: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    bannerFile: {
      type: File,
      default: null,
    },
    existingImageUrl: {
      type: String,
      default: null,
    },
    defaultImageURL: {
      type: String,
      default: null,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    "update:clientId",
    "update:name",
    "update:description",
    "update:bannerFile",
    "clear-existing-image",
  ],
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
  },
};
</script>

<style scoped>
.initialize-survey-step {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-fields {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.banner-description {
  color: rgba(0, 0, 0, 0.6);
}

.default-image-link {
  color: var(--v-brandPrimary-base);
  text-decoration: none;
}

.default-image-link:hover {
  text-decoration: underline;
}
</style>
